/**
 * ML Product Customization Preview (ml-product-6170)
 * - Handles the "Start customizing" button click.
 * - Opens the customized example image in a larger, non-full-screen dialog.
 * - Mirrors the behavior used in the existing ml-custom-now section:
 *   - Prefer clicking the Product Customizer / Zepto button if present.
 *   - Fallback to scrolling to the product form.
 */
(function () {
  'use strict';

  if (window.__mlProduct6170PreviewLoaded) return;
  window.__mlProduct6170PreviewLoaded = true;

  var ROOT_SELECTOR = '.ml-product-6170';
  var START_SELECTOR = '[data-ml-product-6170-start]';
  var EXPAND_TRIGGER_SELECTOR = '[data-ml-product-6170-expand-trigger]';
  var MODAL_SELECTOR = '[data-ml-product-6170-modal]';
  var CLOSE_SELECTOR = '[data-ml-product-6170-close]';
  var MODAL_OPEN_CLASS = 'ml-product-6170-modal-open';
  var ZEPTO_ACTION_SELECTOR = [
    '.product-personalizer .pplr-c-button',
    '.product-personalizer .ptc_button',
    '.product-personalizer button[onclick*="cstmfy_personalize_text"]'
  ].join(', ');

  var activeModal = null;
  var activeTrigger = null;

  function getPurchaseGuardRoot() {
    return document.querySelector('[data-ml-sold-out-guard]');
  }

  function syncPurchaseGuard(root) {
    if (!root) return;
    if (window.MLProductPurchaseGuard && typeof window.MLProductPurchaseGuard.syncRoot === 'function') {
      window.MLProductPurchaseGuard.syncRoot(root);
    }
  }

  function isVisibleElement(element) {
    if (!element || element.hidden) return false;
    if (typeof element.isConnected !== 'undefined' && !element.isConnected) return false;
    if (element.getAttribute('aria-hidden') === 'true') return false;
    if (element.closest('[hidden], [aria-hidden="true"]')) return false;

    var styles = window.getComputedStyle ? window.getComputedStyle(element) : null;
    if (styles && (styles.display === 'none' || styles.visibility === 'hidden' || styles.pointerEvents === 'none')) {
      return false;
    }

    return !!(element.offsetWidth || element.offsetHeight || (element.getClientRects && element.getClientRects().length));
  }

  function isProductSoldOut() {
    var root = getPurchaseGuardRoot();
    if (!root) return false;

    syncPurchaseGuard(root);
    return root.getAttribute('data-ml-sold-out-active') === 'true' || root.classList.contains('ml-product-is-sold-out');
  }

  function showSoldOutNotice() {
    var root = getPurchaseGuardRoot();
    if (!root) return;

    syncPurchaseGuard(root);
    var notice = root.querySelector('[data-ml-sold-out-message]:not([hidden])');
    if (notice && notice.scrollIntoView) {
      notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function isUsableButton(button) {
    if (!button) return false;
    if (button.disabled) return false;
    if (button.getAttribute('aria-disabled') === 'true') return false;
    if (button.getAttribute('data-ml-sold-out-disabled') === 'true') return false;
    return isVisibleElement(button);
  }

  function isZeptoActionReady(button) {
    if (!isUsableButton(button)) return false;

    return typeof window.cstmfy_personalize_text === 'function' ||
      /cstmfy_personalize_text/.test(button.getAttribute('onclick') || '');
  }

  function findZeptoAction(scope) {
    if (!scope || !scope.querySelectorAll) return null;

    var actions = scope.querySelectorAll(ZEPTO_ACTION_SELECTOR);
    for (var i = 0; i < actions.length; i++) {
      if (isZeptoActionReady(actions[i])) return actions[i];
    }

    return null;
  }

  function tryClickCustomizerButton() {
    var root = getPurchaseGuardRoot();
    if (!root) return false;

    syncPurchaseGuard(root);
    var customizerButton = findZeptoAction(root) || findZeptoAction(document);
    if (!customizerButton) return false;

    try {
      customizerButton.click();
      if (customizerButton.scrollIntoView) {
        customizerButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function fallbackScroll() {
    var root = getPurchaseGuardRoot();
    if (!root) return false;

    syncPurchaseGuard(root);
    var nativeAction = root.querySelector('[data-ml-add-to-cart]');
    var buttonGroup = nativeAction && nativeAction.closest ? nativeAction.closest('.product-form__buttons') : null;
    var purchaseForm = nativeAction && nativeAction.closest ? nativeAction.closest('form') : null;
    var candidates = [
      nativeAction,
      buttonGroup,
      purchaseForm
    ];

    for (var i = 0; i < candidates.length; i++) {
      var target = candidates[i];
      if (!target || !root.contains(target)) continue;
      if (!isVisibleElement(target) || !target.scrollIntoView) continue;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }

    return false;
  }

  function focusElement(element) {
    if (!element || typeof element.focus !== 'function') return;

    try {
      element.focus({ preventScroll: true });
    } catch (e) {
      element.focus();
    }
  }

  function getFocusableElements(container) {
    if (!container) return [];

    var selectors = [
      'a[href]',
      'area[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'iframe',
      'object',
      'embed',
      '[contenteditable="true"]',
      '[tabindex]:not([tabindex="-1"])'
    ];

    return Array.prototype.slice.call(container.querySelectorAll(selectors.join(','))).filter(function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function closePreviewModal(modal, restoreFocus) {
    var modalToClose = modal || activeModal;
    if (!modalToClose) return;

    modalToClose.hidden = true;
    modalToClose.setAttribute('aria-hidden', 'true');

    if (activeModal === modalToClose) {
      activeModal = null;
      document.body.classList.remove(MODAL_OPEN_CLASS);

      if (restoreFocus !== false && activeTrigger && document.contains(activeTrigger)) {
        focusElement(activeTrigger);
      }
      activeTrigger = null;
    }
  }

  function openPreviewModal(root, trigger) {
    if (!root) return;

    var modal = root.querySelector(MODAL_SELECTOR);
    if (!modal) return;

    if (activeModal && activeModal !== modal) {
      closePreviewModal(activeModal, false);
    }

    activeModal = modal;
    activeTrigger = trigger || null;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add(MODAL_OPEN_CLASS);

    window.requestAnimationFrame(function () {
      focusElement(modal.querySelector('.ml-product-6170__modal-panel') || modal);
    });
  }

  function bind(root) {
    if (!root || root.dataset.mlp6170Bound === 'true') return;
    root.dataset.mlp6170Bound = 'true';

    var btn = root.querySelector(START_SELECTOR);
    if (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();

        if (isProductSoldOut()) {
          showSoldOutNotice();
          return;
        }

        var didClick = tryClickCustomizerButton();
        if (!didClick) fallbackScroll();
      });
    }

    var expandTrigger = root.querySelector(EXPAND_TRIGGER_SELECTOR);
    var modal = root.querySelector(MODAL_SELECTOR);

    if (expandTrigger && modal) {
      expandTrigger.addEventListener('click', function (evt) {
        evt.preventDefault();
        openPreviewModal(root, expandTrigger);
      });

      modal.addEventListener('click', function (evt) {
        var modalPanel = modal.querySelector('.ml-product-6170__modal-panel');
        var target = evt.target;
        var targetElement = target && target.nodeType === 1 ? target : target && target.parentElement;
        var closeTarget = targetElement && typeof targetElement.closest === 'function'
          ? targetElement.closest(CLOSE_SELECTOR)
          : null;
        var clickedCloseButton = closeTarget && modal.contains(closeTarget);
        var clickedOutsidePanel = modalPanel && target && !modalPanel.contains(target);

        if (!clickedCloseButton && !clickedOutsidePanel) return;

        evt.preventDefault();
        closePreviewModal(modal, true);
      });
    }
  }

  function init(context) {
    var scope = context || document;
    var nodes = scope.querySelectorAll(ROOT_SELECTOR);
    if (!nodes || nodes.length === 0) return;

    nodes.forEach(function (node) {
      bind(node);
    });
  }

  document.addEventListener('keydown', function (evt) {
    if (!activeModal || activeModal.hidden) return;

    if (evt.key === 'Escape' || evt.key === 'Esc') {
      evt.preventDefault();
      closePreviewModal(activeModal, true);
      return;
    }

    if (evt.key !== 'Tab') return;

    var focusableElements = getFocusableElements(activeModal);
    if (focusableElements.length === 0) {
      evt.preventDefault();
      focusElement(activeModal.querySelector('.ml-product-6170__modal-panel') || activeModal);
      return;
    }

    var first = focusableElements[0];
    var last = focusableElements[focusableElements.length - 1];

    if (evt.shiftKey && document.activeElement === first) {
      evt.preventDefault();
      focusElement(last);
    } else if (!evt.shiftKey && document.activeElement === last) {
      evt.preventDefault();
      focusElement(first);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor support: re-bind when a section is reloaded
  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    init(event.target);
  });
})();
